import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';

window.addEventListener('DOMContentLoaded', () => {
  enableGnav();
});

function enableGnav() {
  const gnav = document.querySelector('.lp__header');
  const button = document.querySelector('.lp__header__open');
  const nav = document.querySelector('.lp__header__links');
  for (let link of document.querySelectorAll('.lp__header__link')) {
    link.addEventListener('click', close);
  }

  function open() {
    disableBodyScroll(nav);
    gnav.classList.add('-open');
  }

  function close() {
    enableBodyScroll(nav);
    gnav.classList.remove('-open');
    document.documentElement.style.scrollBehavior = 'auto';  // iOSでgnavを閉じるときに、bodyが高速スクロールして戻ってくるのを一瞬で戻すようにする
    setTimeout(() => document.documentElement.style.scrollBehavior = '');
  }

  button.addEventListener('click', () => {
    if (gnav.classList.contains('-open')) {
      close();
    } else {
      open();
    }
  });

  window.addEventListener('custom:media', close);
}